module.exports = __webpack_public_path__ + "img/follow_wxremark.9cf9e0d9.png";